import type {
  FieldBootstrapResponse,
  FieldSyncPushOperation,
  FieldSyncResponse,
} from '@/mobile/sync/fieldSyncTypes';

async function parseJson<T>(response: Response): Promise<T> {
  if (!response.ok) {
    const text = await response.text();
    throw new Error(text || `HTTP ${response.status}`);
  }

  return response.json() as Promise<T>;
}

export async function fetchFieldBootstrap(): Promise<FieldBootstrapResponse> {
  const response = await fetch('/api/field/bootstrap', {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
    },
    credentials: 'same-origin',
  });

  return parseJson<FieldBootstrapResponse>(response);
}

export async function postFieldSync(body: {
  deviceId?: string;
  lastPullAt?: string | null;
  push?: FieldSyncPushOperation[];
}): Promise<FieldSyncResponse> {
  const response = await fetch('/api/field/sync', {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
    },
    credentials: 'same-origin',
    body: JSON.stringify(body),
  });

  return parseJson<FieldSyncResponse>(response);
}
